import { createRouter, createWebHistory } from 'vue-router'
import VRView from '../views/index.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: VRView
  }
  // {
  //   path: '/index',
  //   name: 'index',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/pro.vue')
  // }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
